import { OPERACIONES } from "./index.js";
import { LcapiiService } from "../shared/services/LcapiiService.js";

// Único lugar donde se cruza el registro de operaciones con los permisos de
// LCApii. Lo usan el navbar, la home y el router.

export const operacionesPermitidas = () =>
  OPERACIONES.filter((op) => LcapiiService.tienePermiso(op.pid));

export const tieneAcceso = (operacion) => !!operacion && LcapiiService.tienePermiso(operacion.pid);
